<style lang="scss">
  @import "product-category-list";
</style>

<script>
import jackets from '../../../data/Jackets.json'
import tShirts from '../../../data/T-shirts.json'
import merchandise from '../../../data/merchandise'
import { mapGetters } from 'vuex'
import { JACKETS, T_SHIRTS, MERCHANDISE } from '../../../utils/constant.js'

export default {
  data () {
    return {
      products: {},
      currency: [{
        code: 'USD',
        symbol: '$'
      }],
      displayAllProducts: false
    }
  },

  computed: {
    ...mapGetters(['selectedProductCategory', 'currencySymbol'])
  },

  watch: {
    selectedProductCategory: {
      handler () {
        this.displayProducts()
      }
    }
  },

  mounted () {
    this.displayProducts()
  },

  methods: {
    /**
     * This method decides whether to display products
     * category wise or to show all of them
     */
    displayProducts () {
      if (this.$router.currentRoute.path === '/all-products') {
        this.displayAllProducts = true
        this.products = [...jackets.products, ...tShirts.products, ...merchandise.products]
      } else {
        this.displayAllProducts = false
        this.productListCategory()
      }
    },

    /**
     * This method will display the products
     * according to the selected category
     */
    productListCategory () {
      switch (this.selectedProductCategory) {
        case JACKETS:
          this.products = jackets.products
          break
        case T_SHIRTS:
          this.products = tShirts.products
          break
        case MERCHANDISE:
          this.products = merchandise.products
          break
        default:
          this.products = jackets.products
      }
    },

    /**
     * This method will add product to the cart
     * @param product
     */
    addToCart (product) {
      this.$store.dispatch('increment', {
        product: product,
        quantity: 1
      })
    },

    /**
     * This method routes to product listing page
     */
    showAllProducts () {
      this.$router.push('/all-products').catch(err => { console.error(err) })
    }
  }
}
</script>

<template>
  <div
    id="product-category"
    class="container bg-white"
  >
    <div
      class="row justify-content-center m-0"
    >
      <div
        v-for="product in products"
        :key="product.productId"
        class="mt-4 col-md-4 col-lg-2 col-sm-12 product-border"
      >
        <div
          v-if="!displayAllProducts"
        >
          <button
            id="add-to-cart"
            class="btn btn-lg add-cart border-primary text-primary bg-white"
            type="btn"
            @click="addToCart(product)"
          >
            <i class="fa fa-cart-plus text-primary fa-2x" />
          </button>
        </div>
        <router-link
          :id="'product-' + product.productId"
          :to="{name:'Product', params:{productId:product.productId,product:product}}"
          class="product-link"
        >
          <div class="text-center">
            <img
              :src="require(`@/assets/images/${product.image}`)"
              class="product-img"
            >
          </div>
          <h5
            id="product-name"
            class="text-center mt-1"
          >
            {{ product.name | truncate(50) }}{{ product.name.length > 50 ? '...' : '' }}
          </h5>
        </router-link>
        <div class="text-center">
          <h4
            v-for="c in currency"
            id="product-price"
            :key="c.code"
            class="font-weight-bold mt-1"
          >
            <span v-html="currencySymbol" />
            <span>{{ (product.salePrice || product.price).toString() }}</span>
          </h4>
          <div
            id="star-rating"
            class="text-center mt-1"
          >
            <img
              class="star-rating grad"
              src="@/assets/images/transparent-stars.png"
            >
          </div>
          <div>
            <button
              v-if="displayAllProducts"
              id="add-cart"
              class="btn btn-primary font-weight-bold mt-3 pl-4 pr-4"
              type="btn"
              @click="addToCart(product)"
            >
              {{ $t ('label.addToCart') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center mb-3">
      <button
        v-if="!displayAllProducts"
        id="show-all-products"
        class="btn btn-lg border-primary text-primary pl-5 pr-5 mb-5"
        type="btn"
        @click="showAllProducts()"
      >
        {{ $t ('label.showAllProducts') }}
      </button>
    </div>
  </div>
</template>
